import { render, staticRenderFns } from "./CadastroUsuario.vue?vue&type=template&id=0a71d470&scoped=true&"
import script from "./CadastroUsuario.vue?vue&type=script&lang=js&"
export * from "./CadastroUsuario.vue?vue&type=script&lang=js&"
import style0 from "./CadastroUsuario.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CadastroUsuario.vue?vue&type=style&index=1&id=0a71d470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a71d470",
  null
  
)

export default component.exports